// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ea07a3a1","453":"dcd078cf"}[chunkId] + ".chunk.js";
};